import * as React from 'react';
import { useState } from "react";
import Button from 'react-bootstrap/Button';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import SavedSearchRoundedIcon from '@mui/icons-material/SavedSearchRounded';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import '../Controls.css';



function LargeControls(props) {

    const [value, setValue] = useState('buscar');

    return(
        <React.Fragment>            
            {/* Code for big screens */}
            <div className="controls-l">
                <div className="controls-l-row">
                    <div className="controls-l-container">
                        <BottomNavigation sx={{ width: 500 }} value={value} >
                            <BottomNavigationAction
                                label="Buscar"
                                value="buscar"
                                icon={<SavedSearchRoundedIcon
                                onClick={() => setValue('buscar')}/>}
                            />
                            <BottomNavigationAction
                                label="Filtrar"
                                value="filtrar"
                                icon={<FilterListRoundedIcon
                                onClick={() => setValue('filtrar')}/>}
                            />
                            <BottomNavigationAction
                                label="Agregar"
                                value="agregar"
                                icon={<AddRoundedIcon
                                onClick={() => setValue('agregar')} />}
                            />
                        </BottomNavigation>
                        </div>
                </div>
                <h1>{props.queryCase}</h1>
                <div className="controls-l-row">
                    <TabContext value={value}>
                        <div className='tab-container'>
                            <TabPanel value='buscar'>
                                <FormControl className='form-input-tag left' fullWidth>
                                    <div >
                                        <InputLabel id="demo-simple-select-label">Criterio</InputLabel>
                                        <Select
                                            fullWidth 
                                            onChange={(e) => {props.setLoaded(false); props.setCriteria(e.target.value)}} label="Criterio">
                                            <MenuItem value={0}>Radicado</MenuItem>
                                            <MenuItem value={1}>Demandante</MenuItem>
                                            <MenuItem value={2}>Demandado</MenuItem>
                                            {/* <MenuItem value={3}>Fecha</MenuItem> */}
                                            <MenuItem value={4}>Materia</MenuItem>
                                        </Select>
                                    </div>
                                </FormControl>
                                <FormControl className='form-input-tag right' fullWidth>
                                    <div>
                                        <TextField
                                            className='please'
                                            id="filled-basic"
                                            placeholder="Detalle"
                                            variant="filled"
                                            onChange={(e) => {props.setLoaded(false); props.setQueryCase(e.currentTarget.value)}} 
                                        /> 
                                    </div>
                                </FormControl>
                            </TabPanel>
                            <TabPanel value='filtrar'>
                                <FormControl fullWidth>
                                    <div className='form-TextField-tag left'>
                                        <InputLabel id="demo-simple-select-label">Criterio</InputLabel>
                                        <Select
                                            fullWidth
                                            onChange={(e) => {props.setLoaded(false); props.setCriteria(e.target.value)}} label="Criterio">
                                            <MenuItem value={0}>Radicado</MenuItem>
                                            <MenuItem value={1}>Demandante</MenuItem>
                                            <MenuItem value={2}>Demandado</MenuItem>
                                            <MenuItem value={3}>Fecha</MenuItem>
                                            <MenuItem value={4}>Materia</MenuItem>
                                        </Select>
                                    </div>
                                </FormControl>
                                <FormControl fullWidth>
                                    <div className='form-input-tag right'>
                                    <InputLabel id="demo-simple-select-label">Orden</InputLabel>
                                        <Select
                                            fullWidth
                                            label="Orden"
                                            onChange={(e) => {props.setLoaded(false); props.setOrder(e.target.value);}}
                                            >
                                            <MenuItem value={1}>Ascendente</MenuItem>
                                            <MenuItem value={2}>Descendente</MenuItem>
                                        </Select>
                                    </div>
                                </FormControl>
                            </TabPanel>
                            <TabPanel value='agregar'>
                            { props.addLoad ?
                                <FormControl className='add-proceso-l' fullWidth>
                                    <div >
                                        <TextField id="filled-basic" placeholder="Digita el radicado del proceso" variant="filled" 
                                                    onChange={(e) => {
                                                        if (e.target.value.length === 23) {
                                                            props.setNumeroCaso(e.target.value);
                                                            props.setNumeroValido(true);
                                                    } else props.setNumeroValido(false);
                                                    }}/>
                                    </div>
                                    <div className='add-proceso-button-l'>
                                    <Button className='add-case' disabled={!props.numeroValido}
                                                onClick={() => {props.newCase(props.numeroCaso); props.setAddLoad(false)}}>Agregar </Button></div>
                                </FormControl> :
                                <div className='loading'><CircularProgress /></div>}
                            </TabPanel>
                        </div>
                    </TabContext>
                </div>
            </div>
        </React.Fragment>
    )
}

export { LargeControls }